<script setup>
import { onMounted, onUnmounted } from 'vue';

const emit = defineEmits(['hidden']);

let modalEl = null;

const handleModalHidden = () => {
  if (document.activeElement && modalEl.contains(document.activeElement)) {
    document.activeElement.blur();
  }
}

onMounted(() => {
  modalEl = document.getElementById('deleteFromCartCompleteModal');
  if (modalEl) {
    modalEl.addEventListener('hide.bs.modal', handleModalHidden);
    modalEl.addEventListener('hidden.bs.modal', handleModalHidden);
  }
})

onUnmounted(() => {
  if(modalEl) {
    modalEl.removeEventListener('hide.bs.modal', handleModalHidden);
    modalEl.removeEventListener('hidden.bs.modal', handleModalHidden);
  }
})
</script>
<template>
  <div class="modal com_modal2 fade" id="deleteFromCartCompleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">選択した商品をカートから削除しました</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd2" data-bs-dismiss="modal">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>
